var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-percent-averages"},[_c('div',{staticClass:"dpa-body"},[_vm._t("content")],2),(_vm.isDataIn)?_c('div',{staticClass:"dpa-footer"},[_c('p',[_vm._v("*Data represents percent averages")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }